'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var dateTimeHelper = require('../helper/dateTimeHelper');
var assetsHelper = require('../helper/assetsHelper');
var ScrollView = require('osx-scrollview');
var storeHelper = require('../helper/storeHelper');
var i18nHelper = require('../helper/i18n');

var testData = '[{"name":"最新版本","revision":29,"addtime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html",' +
    '"reviews":[' +
      '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","author":"qwe","data":"rtyaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
    '{"id":322,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"sd","type":"comment","addtime":"2017-05-03T10:50:14.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' +
      '{"id":305,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"撒发射点发阿萨德发送到发生大幅阿斯蒂芬阿萨德发生大幅阿萨德发生的发生大幅阿斯蒂芬阿斯蒂芬阿斯蒂芬撒旦","data":"去","type":"comment","addtime":"2017-05-03T10:35:20.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"}' +
    ']' +
    '}]'
var testReviews = JSON.parse(testData);

var AppReviews = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    projectReviews: React.PropTypes.array,
    syncID: React.PropTypes.string.isRequired,
    onLoadProjecReviews: React.PropTypes.func.isRequired,
    onCloseAppReviews: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      currentRevision: -1,
    };
  },
  componentWillReceiveProps: function (nextProps) {
    if (this.state.currentRevision === -1 && nextProps.projectReviews.length > 0) {
      this.setState({
        currentRevision: nextProps.projectReviews[0].revision
      });
    }
  },
  componentDidMount: function () {
    this.props.onLoadProjecReviews(this.props.syncID);
    this.adjustScroll();
  },

  isBad: false,
  adjustScroll: function() {
    var h = $('.scroll-view').height();
    if(!this.isBad && h === 0) {
      this.isBad = true;
    }
    //兼容部分浏览器不识别flex布局生成的高度
    if(this.isBad) {
      var box = $('.revisions-and-reviews');
      var height = box.height();
      box.find('.scroll-view').css({height: height});
      box.find('.thumb').css({height: 0});
    }
  },
  componentDidUpdate: function () {
    var dom = ReactDOM.findDOMNode(this.refs.reviews);
    if (dom) {
      dom.scrollTop = 1;
      dom.scrollTop = 0;
    }

    this.adjustScroll();

  },
  render: function () {
    var reviews = this.props.projectReviews;
    var currentRevision = this.state.currentRevision;
    //var reviews = testReviews;
    //var currentRevision = 29;
    return (
      <div className="app-reviews">
        <div className="app-reviews-dialog">
          <h2>{this.props.name}</h2>
          <img onClick={this.props.onCloseAppReviews} className="close" src={assetsHelper.getAsset('close-30.png')}/>
          {reviews.length > 0 &&
          <div className="revisions-and-reviews">
            <div className="revisions">
              <ScrollView>
                {reviews.map(function (review) {
                  return <div className={review.revision === currentRevision ? 'revision current' : 'revision'}
                              onClick={this.onSwitchRevision.bind(this, review.revision)}>
                    <p className="title">{review.name}</p>
                    <p className="time">{dateTimeHelper.readableTime(review.addtime)}</p>
                  </div>;
                }, this)}
              </ScrollView>
            </div>
            <div className="reviews" ref="reviews">
              <ScrollView>
                {reviews.map(function (revision) {
                  return revision.reviews.filter(function (item) {
                    return item.revision === currentRevision;
                  }).map(function (review) {

                    if (review.type === 'comment') {
                      return <div className="review comment">
                        <div className="title">
                          <span className="name">{review.author}</span>
                          <span className="time">{dateTimeHelper.readableTime(review.addtime)}</span>
                        </div>
                        <p className="content">{review.data}</p>
                        <div><a href={review.URL}>{review.pagename || i18nHelper.get('VIEW_COMMENT')}</a></div>
                      </div>;
                    }
                    return <div className="review notation">
                      <div className="title">
                        <span className="name">{review.author}</span>
                        <span className="time">{dateTimeHelper.readableTime(review.addtime)}</span>
                      </div>
                      <p className="content">{i18nHelper.get('PAINT_TIP')}</p>
                      <div><a href={review.URL}>{review.pagename || i18nHelper.get('VIEW_MARK')}</a></div>
                    </div>;
                  });
                })}
              </ScrollView>
            </div>
          </div>
          }
          {reviews.length === 0 && <p className="no-data">{i18nHelper.get('NO_REVIEW')}</p>}
        </div>
      </div>
    );
  },
  onSwitchRevision: function (revision) {
    this.setState({
      currentRevision: revision
    });
  }
});

module.exports = AppReviews;


// WEBPACK FOOTER //
// ./src/views/AppReviews.jsx